<template>
  <div class="DocumentBlock -eshop" v-if="validProductList.length || edit" :id="'eshop' + page.id">
    <div 
      class="DocumentElement -eshop"
      v-aw-driver-element="'DocumentEshopContent'"
    >
      <!-- <div class="TableResponsiveWrapper"> -->

      <div class="text-sm">
        <div
          class="grid gap-x-4 px-5 md:pl-12 md:pr-6 xl:pl-16 pb-2 border-b font-medium"
          :class="[showStock?'grid-cols-6 sm:grid-cols-9':'grid-cols-5 sm:grid-cols-8']"
        >
          <div class="col-span-1 hidden sm:block break-words relative">
            <aw-dropdown
              v-if="edit"
              placement="bottom-start"
              :offset="[0, 6]"
              class="absolute -left-6 cursor-pointer"
            >
              <template v-slot:btn="{ toggle }">
                <div v-aw-driver-element="'DocumentEshopSettings'" class="mr-2.5">
                  <aw-icon
                    @click="toggle"
                    icon="cog"
                    class="w-4 h-4 text-gray-400 hover:text-gray-500 cursor-pointer"
                  ></aw-icon>
                </div>
              </template>
              <template v-slot:dropdown="{ opened, dropdown }">
                <div
                  v-show="opened"
                  :ref="dropdown"
                  class="Dropdown Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
                >
                  <div>
                    <toggle-button class="flex items-center cursor-pointer p-2" v-model="showStock">
                      <span class="ml-2.5 text-sm text-gray-500">
                        {{$t('Show stock')}}
                      </span>
                    </toggle-button>
                  </div>
                </div>
              </template>
            </aw-dropdown>
            {{$t('Code')}}
          </div>
          <div class="col-span-2 sm:col-span-3 break-words">{{$t('Product')}}</div>
          <div v-if="showStock" class="col-span-1 break-words text-right">{{$t('Stock')}}</div>
          <div class="col-span-2 break-words text-right">{{$t('Price')}}</div>
          <div class="col-span-1 sm:col-span-2 break-words text-right" v-if="!edit">{{$t('Amount')}}</div>
          <div class="col-span-1 break-words hidden">
            <div class="flex items-center">
              <!--
              <span
                class="DocumentCircle mr-2.5 sm:mr-3.5"
                :class="{
                  'DocumentCircle--active':
                    $store.state.bcSelected.selected[products.id]
                }"
                @click.stop="
                  $store.dispatch('bcSelected/select', { item: products })
                "
              ></span>
              -->
              <span class="cursor-move text-gray-400 hover:text-gray-500">
                <!--
                <span class="-mx-0.5">
                  <aw-icon
                    icon="dots"
                    class="w-4 h-4 -mx-1 "
                  ></aw-icon>
                  <aw-icon
                    icon="dots"
                    class="w-4 h-4 -mx-1 "
                  ></aw-icon>
                </span>
                -->
              </span>
            </div>
          </div>
        </div>
        
        <template v-for="(product, index) in validProductList" :key="index">
          <document-element-eshop-product 
            :model-value="product" 
            :index="index" 
            :focus-index="focusedIndex" 
            :page="page" 
            @delete="deleteProduct" 
            :amount="basketAmount[index]"
            :showStock="showStock"
            @update:amount="updateAmount(product.id, $event)" 
            @update:modelValue="updateProduct(index, $event)"
            @change-focus-index="updateFocusIndex"
          />
        </template>

        <div
          v-if="edit"
          class="w-full px-5 md:pl-12 md:pr-6 xl:pl-16 my-3"
        >
          <button 
            class="w-full flex justify-end items-center text-gray-400 hover:text-gray-500 cursor-pointer"
            @click.stop.prevent="addProduct"
            v-aw-driver-element="'DocumentEshopButtonAddProduct'"
          >
            <h3 class="font-medium">
              {{$t('Add product')}}
            </h3>
            <aw-icon
              icon="plus"
              class="w-6 h-6 mx-3"
            ></aw-icon>
            <!--
            <aw-icon
              icon="cog"
              class="
                w-4
                h-4
                text-gray-400
                hover:text-gray-500
                
                
                cursor-pointer
              "
            ></aw-icon>
            -->
          </button>
        </div>

        <div
          v-if="!edit" 
          class="grid grid-cols-6 sm:grid-cols-9 items-center gap-x-4 gap-y-6 px-5 md:pl-12 md:pr-6 xl:pl-16 mt-4 mb-6"
        >
          <div class="col-span-4 sm:col-span-6 text-right whitespace-nowrap">
            {{ totalPrice }} {{ currency.symbol }}
          </div>
          <div class="col-span-2 sm:col-span-3 text-right text-base whitespace-nowrap">
            <a 
              href="" 
              class="btn btn-primary w-16 sm:w-auto text-center sm:text-left flex flex-row items-center" 
              @click.stop.prevent="addToCart"
            >
              <aw-icon
                icon="cart"
                class="inline-block w-4 h-4 text-white "
              />
              <span class="hidden sm:inline-block">
                {{$t('Add to cart')}}
              </span>
            </a>
          </div>
        </div>
      </div>

      <!-- </div> -->

      <div class="DocumentBlock__PanelLeft -table"></div>

      <!-- panel s moznosti noveho elementu -->
      <!-- <document-hot-action /> -->
    </div>
    <div class="DocumentBlock__PanelRight -eshop"></div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import useBcCartStore from '@/frontapp/store/bcCart'
import { DocumentApi } from '../../test-api/index.ts'
import Toast from '@/frontapp/mixins/actions/Toast'
import handleApiError from '../../utils/handleApiError'

const documentApi = new DocumentApi({}, '/api/v2')

export default {
  emits: ['onstockcolchanged'],
  props: {
    page: Object
  },
  data() {
    return {
      amounts: {},
      focusedIndex: null
    }
  },
  methods: {
    addProduct() {
      const products = this.products
      products.push({
        id: null,
        product_id: null,
        code: '',
        name: '',
        price: null,
      })
      this.products = products
    },
    deleteProduct(index) {
      const products = this.products
      products.splice(index, 1)
      this.products = products
    },
    updateAmount(productId, amount) {
      this.amounts[productId] = amount
    },
    updateProduct(index, product) {
      const products = this.products
      products.splice(index, 1, product)
      this.products = products
    },
    async addToCart() {
      const items = []
      this.validProductList.forEach((product) => {
        if (!product.id) {
          return
        }

        if (this.amounts[product.id]) {
          items.push({
            productId: product.id,
            amount: this.amounts[product.id]
          })
        }
      })

      if (items.length) {
        await handleApiError(() => documentApi.basketBulkInsert(this.bcDocumentStore.document.id, this.page.id, items))
        this.bcCartStore.reset()
        Toast(
          'success',
          this.$t('Products added to cart')
        )
      }
    },
    updateFocusIndex(index) {
      this.focusedIndex = index
    },
  },
  computed: {
    ...mapStores(useBcDocumentStore, useBcSelectedStore, useBcCartStore),
    products: {
      get () {
        if (this.page.data.products) {
          return this.page.data.products
        }

        return []
      },
      set (val) {
        this.bcDocumentStore.findElementInDocument(this.page.id).data.products = val
      }
    },
    showStock: {
      get() {
        return this.page.data.showStock??false
      },
      set (val) {
        this.bcDocumentStore.findElementInDocument(this.page.id).data.showStock = val
        this.$emit('onstockcolchanged', val);
      }
    },
    validProductList() {
      if (this.edit) {
        return this.products
      }

      return this.products.filter((product) => product.name !== '' && product.name !== null)
    },
    currency() {
      return this.$presenter.design.currency
    },
    edit() {
      return this.bcDocumentStore.edit
    },
    basketAmount() {
      return this.validProductList.map((product) => {
        if (!product.id) {
          return null
        }

        return this.amounts[product.id] ? this.amounts[product.id] : null
      })
    },
    totalPrice() {
      let totalPrice = 0
      this.validProductList.forEach((product) => {
        if (!product.id) {
          return
        }

        if (this.amounts[product.id]) {
          totalPrice += product.price.price * this.amounts[product.id]
        }
      })

      return totalPrice
    },
  },
  mounted () {
    if (this.validProductList.length === 0 && this.edit) {
      this.addProduct()
    }
  },
}
</script>

<style lang="scss" scoped>
.TableFooterSwitch {
  @apply hidden p-2.5 pb-4 text-right;
}

.Table .code {
  @apply hidden;
}

@media (max-width: 600px) {
  .TableFooterSwitch {
    @apply block;
  }

  .TableFooter {
    @apply hidden;
  }
  .Table {
    th:nth-child(1),
    th:nth-child(2),
    th:nth-child(6),
    td:nth-child(1),
    td:nth-child(2),
    td:nth-child(6) {
      @apply hidden;
    }

    td:nth-child(2) {
      max-width: 60px;
    }
  }

  .Table .code {
    @apply block;
  }
}
</style>
